import { useMemo } from 'react';

export default function Confetti({ intensity = 'med' }: { intensity?: string }) {
  const count = useMemo(() => (intensity === 'high' ? 160 : intensity === 'low' ? 60 : 100), [intensity]);

  const pieces = useMemo(
    () =>
      new Array(count).fill(0).map((_, i) => {
        const w = 6 + Math.random() * 6;
        const h = 10 + Math.random() * 10;
        const left = Math.random() * 100;
        const dur = 7 + Math.random() * 8;
        const delay = Math.random() * 3;
        const drift = (Math.random() * 120 - 60) + 'px';
        const spin = (360 + Math.random() * 720) + 'deg';
        const hue = Math.floor(Math.random() * 360);

        return (
          <div
            key={i}
            className="confetti overlay-layer"
            style={{
              left: `${left}%`,
              width: w,
              height: h,
              background: `hsl(${hue}, 80%, 55%)`,
              animationDuration: `${dur}s, ${Math.max(5, dur - 1)}s, ${dur}s`,
              animationDelay: `${delay}s, ${delay}s, ${delay}s`,
              ['--drift' as string]: drift,
              ['--spin' as string]: spin,
              borderRadius: '2px',
            }}
          />
        );
      }),
    [count]
  );

  return <div className="overlay-root">{pieces}</div>;
}
